<template>
    <label class="checkbox">
        <input type="checkbox" :name="name" class="checkbox__input" :checked="state" @change="onCheckboxChange" />
        <span class="checkbox__body" :class="{ 'checkbox__body--invalid': is_invalid}"/>
    </label>
</template>
<script src="./checkbox.js" />
<style src="./checkbox.scss" lang="scss" scoped />
